import CalendarEvents from './CalendarEvents';
import Swiper, { Navigation, Mousewheel, FreeMode} from 'swiper';

window.calendarEvents = {};

document.addEventListener('DOMContentLoaded', () => {
    if(document.querySelector('.jsCalendarEvents')) {
        let block = document.querySelector('.jsCalendarEvents');
        let slider = new Swiper(block.querySelector('.slider__inner'), {
            modules: [Navigation, Mousewheel, FreeMode],
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 32,
            speed: 750,
            freeMode: true,
            mousewheel: true,
            watchSlidesProgress: true,
        
            navigation: {
                prevEl: block.querySelector('.swiper-button-prev'),
                nextEl: block.querySelector('.swiper-button-next'),
            },
        
            breakpoints: {
                0:{
                    spaceBetween: 8,
                },
        
                834: {
                    spaceBetween: 16,
                },
        
                1024: {
                    spaceBetween: 24,
                },
        
                1260: {
                    spaceBetween: 32,
                },
            }
        });

        window.calendarEvents.slider = slider;
        
        let calendar = new CalendarEvents({
            element: block,
        })

        window.calendarEvents.main = calendar;

        block.querySelector('.swiper-button-prev').addEventListener('click', () =>{
            let width = block.querySelector('.slider__inner').offsetWidth * 0.85;
            let translate = slider.getTranslate()
            slider.translateTo(translate + width, 900)
            slider.update()
        })
        block.querySelector('.swiper-button-next').addEventListener('click', () =>{
            let width = block.querySelector('.slider__inner').offsetWidth * 0.85;
            let translate = slider.getTranslate()
            slider.translateTo(translate - width, 900)
            slider.update()
        })
    }
})